// import React from "react";

// /**
//  * Catches errors thrown by react-toastify (e.g. internal setToggle issues) so they do not crash the whole app.
//  * On error, remounts the wrapped ToastContainer via a new key instead of returning null (which removed the container and broke all toasts).
//  */
// export class ToastErrorBoundary extends React.Component {
// 	constructor(props) {
// 		super(props);
// 		this.state = { remountKey: 0 };
// 	}

// 	componentDidCatch(error, info) {
// 		// eslint-disable-next-line no-console
// 		console.error("ToastErrorBoundary caught an error:", error, info);
// 		this.setState((s) => ({ remountKey: s.remountKey + 1 }));
// 	}

// 	render() {
// 		const child = this.props.children;
// 		if (!React.isValidElement(child)) {
// 			return child;
// 		}
// 		return React.cloneElement(child, {
// 			key: `toast-error-boundary-${this.state.remountKey}`,
// 		});
// 	}
// }



import React from "react";

/**
 * Catches toast-related errors (e.g. react-toastify setToggle on undefined) so the app never crashes.
 * After a short delay, re-mounts the container so future toasts still work.
 */
export class ToastErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error("ToastErrorBoundary caught an error:", error, info);
        // Re-mount container after a tick so future toasts work
        this.recoveryTimer = setTimeout(() => this.setState({ hasError: false }), 100);
    }

    componentWillUnmount() {
        if (this.recoveryTimer) clearTimeout(this.recoveryTimer);
    }

    render() {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children;
    }
}


